export const lg_menu_mainpage = {
    lg_menu_mainpage_th: [
        ["mdi-home", "หน้าแรก", "/"],
        ["mdi-information", "เกี่ยวกับเรา", "/about"],
        ["mdi-tag-multiple", "ราคา", "/pricing"],
        ["mdi-email", "ติดต่อเรา", "/contact"],
        ["mdi-message-video", "เข้าประขุม", "/joinmeetid"],
      ],
    lg_menu_mainpage_en: [
        ["mdi-home", "Home", "/"],
        ["mdi-information", "About", "/about"],
        ["mdi-tag-multiple", "Pricing", "/pricing"],
        ["mdi-email", "Contact", "/contact"],
        ["mdi-message-video", "Join Meeting with ID", "/joinmeetid"],
      ],
  };
  